export const WHATSAPP_NUMBER =
  import.meta.env.VITE_WHATSAPP_NUMBER || "1234567890";
export const SITE_URL =
  import.meta.env.VITE_SITE_URL || "https://localhost:5173";

export const getWhatsAppUrl = (
  message = "Hi! I want to know more about your English courses.",
) => {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
};

export const getCourseEnrollUrl = (courseTitle) => {
  const message = `Hi! I want to join the "${courseTitle}" class.`;
  return getWhatsAppUrl(message);
};

export const getCourseDemoUrl = (courseTitle) => {
  const message = `Hi! I'd like to book a demo for the course: "${courseTitle}". Please share available time slots.`;
  return getWhatsAppUrl(message);
};
